var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M17.5 3.275v10.95c0 .65-.75 1.008-1.25.608l-.858-.691a7 7 0 0 0-1.434-.9 7 7 0 0 0-.625-.267v-8.45c.209-.075.417-.167.625-.267a7.1 7.1 0 0 0 1.434-.9l.858-.691c.5-.4 1.25-.042 1.25.608"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M12.708 4.725A7.4 7.4 0 0 1 10.7 5H6.25a3.75 3.75 0 0 0 0 7.5l2.04 4.078c.282.565.858.922 1.49.922h1.053l-.833-5h.7c.683 0 1.358.092 2.008.275q.313.087.625.2v-8.45a9 9 0 0 1-.625.2",
  opacity: 0.4
})));
export default SvgNotice;